import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Routes from './Routes'
import theme from './theme'

const root = ReactDOM.createRoot(document.querySelector('body > main'))
root.render(
  <React.StrictMode>
    <ThemeProvider {...{theme}}>
      <CssBaseline enableColorScheme />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Routes/>
    </ThemeProvider>
  </React.StrictMode>
)
